import { SUPPORT_DETAILS_SAVE_ACTION }  from '../action-types';
import { SUPPORT_DETAILS_NAME_CHANGE_MUTATION, SUPPORT_DETAILS_EMAIL_CHANGE_MUTATION, SUPPORT_DETAILS_SUBJECT_CHANGE_MUTATION, 
  SUPPORT_DETAILS_MESSAGE_CHANGE_MUTATION, SUPPORT_DETAILS_CLEAR_SUPPORT_DATA_MUTATION } from '../mutation-types';
import support from '../../services/api/Support';
  
export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  support: getSupport()
};

// actions
export const actions = {  
  async [SUPPORT_DETAILS_SAVE_ACTION] ({state}) {
    const response = await support.saveSupportDetails(state.support);    
    return response;
  }
}

// mutations
export const mutations = { 
  [SUPPORT_DETAILS_NAME_CHANGE_MUTATION](state, payLoad) {
    state.support.senderName = payLoad.value;
  },
  [SUPPORT_DETAILS_EMAIL_CHANGE_MUTATION](state, payLoad) {
    state.support.senderEmail = payLoad.value;
  },
  [SUPPORT_DETAILS_SUBJECT_CHANGE_MUTATION](state, payLoad) {
    state.support.subject = payLoad.value;
  },
  [SUPPORT_DETAILS_MESSAGE_CHANGE_MUTATION](state, payLoad) {
    state.support.message = payLoad.value;
  }, 
  [SUPPORT_DETAILS_CLEAR_SUPPORT_DATA_MUTATION](state) {
    state.support = getSupport();
  }
}

function getSupport() {
  return {
    senderName: "",
    senderEmail: "",
    subject: "",
    message: "",
  }
}